import { authSlice } from './slice';

export const { error, loading, login, logout, reset } = authSlice.actions;

export { authSlice };
